const data =  [
  {
    name: 'Benjamin T',
    desc: <>
              <p>Currently a 22 year old student in fintech engineering, I aim to support Trias in their ecosystem changing solutions.</p>
            </>,
    docxUrl: 'https://docs.google.com/document/d/1Txd97g1kZA4uIef3NINu8P3EMOh_STvDxi7c5V_kxxg/edit?usp=sharing',
    address: '0xca8a5851FC3F43b7eCa28AE38d333A8F3fbD8e18',
    votes: 29
  },
  {
    name: 'Michael said',
    desc: <>
              <p>In love with real projects like Trias!</p>
            </>,
    docxUrl: 'https://docs.google.com/document/d/1iSiAp20KGDWWiWapVp8yTlK3V0trNgMNw0IZql5T9OE/edit?usp=sharing',
    address: '0x7971b0a7E96AFEC0863c1F8D630b5accfa2Da51E',
    votes: 10
  },
  {
    name: 'Alexander Grow',
    desc: <>
              <p>"Hunting small cap gems on Twitter. 💎</p>
              <p>Charting TRIAS to $1,000. 📈</p>
              <p>Here for all things blockchain and crypto. Sarcastic meme addict."</p>
            </>,
    docxUrl: 'https://docs.google.com/document/d/1apxxKnqT536XlyCoqpZcjXDRK8alYAZppjkiwDoaBOk/edit?usp=sharing',
    // address: '0x77a1bfe566e5dfeaaf8681576609c35c937f3a7f'
    address: '0x1058961d273c08E37775f8790C58EC3569da7c22',
    votes: 107
  },
  {
    name: 'Peter Wesley',
    desc: <>
              <p>NFT artist</p>
              <p>Designing NFT artworks for Trias</p>
            </>,
    docxUrl: 'https://docs.google.com/document/d/1kzM_Fmrr7lpq_rQSYeK1lEir6NY8aKyy3U1JWWUhHvQ/edit?usp=sharing',
    address: '0xbC57410a1FAAE20FA05513c67C496670745694C2',
    votes:34
  },
  {
    name: 'Alex Urban',
    desc: <>
              <p>Studying statistics, finance, and computer science at University of Cape Town. Work hard, play hard is my modus operandi. My hobbies include crypto and bjj. </p>
            </>,
    docxUrl: 'https://docs.google.com/document/d/1t7Gw_j-xKf0Ih1KAt8lBmzj4vv-fdJbHliIX0sfx2EI/edit?usp=sharing',
    address: '0x6919aE4C89f9ED4A79aE70Fb4cC78396F48A42cA',
    votes: 1
  },
  {
    name: 'Petrit B.',
    desc: <>
              <p>Been in the crypto world for two years. interested in not only currencies but also blockchain.</p>
              <p>TRIAS is for me a platform with a lot of potential</p>
            </>,
    docxUrl: 'https://docs.google.com/document/d/1o0i62DNyXuxhsXDV8DtXbMGkK5LYZ1L-x8d9af1DFbw/edit?usp=sharing',
    address: '0x73300CA3F21201e9fBB1E35db0441660E269A2C1',
    votes: 13
  },
  {
    name: 'amerigo provenzano',
    desc: <>
              <p>Dj and Crypto Fan</p>
            </>,
    docxUrl: 'https://docs.google.com/document/d/1VLLeLIJ6jX5gywoOGlla9qtWB9odUgR9ZOD7qpRr-fA/edit?usp=sharing',
    address: '0xAAb02D7e6424Ea2f23642A8DDFbF115EC33390A7',
    votes: 2
  },
  {
    name: 'Adrian',
    desc: <>
              <p>Crypto Enthusiast searching and finding the most promising crypto projects. Trias is a gem!</p>
            </>,
    docxUrl: 'https://docs.google.com/document/d/1gYJzzgnDvdNyrDh8Krjqtfp4AxxIQeYhTL0muRHrNI8/edit?usp=sharing',
    address: '0x9fF7139026C3040Cb537838D7c302f76256107B3',
    votes: 28
  },
  {
    name: 'Sean Davis- Crypto For The People',
    desc: <>
              <p>I LOVE THIS PROJECT! I am a youtuber and twitter personality that makes TRIAS easy to understand and has Lazer eyes for TRIAS.  Vote for Me!</p>
            </>,
    docxUrl: 'https://docs.google.com/document/d/1b0zIMX9n-pTR6wOym3xr5nSyzWTgOcg5h1PWvUy3si8/edit?usp=sharing',
    address: '0xFE3C8aA78d2b464483ec967A8c1b45A772A2CE82',
    votes: 48
  },
  {
    name: 'PodLive',
    desc: <>
              <p>A professional customized product supplier and loyal community supporter of Trias</p>
            </>,
    docxUrl: 'https://docs.google.com/document/d/1f6zLmRD6xCx9ZUsJ3B1n3wpU_eBfObzkLIoXqIaky40/edit?usp=sharing',
    address: '0x68c74E859F538a196D769b7E969bC7F286Cb2F0A',
    votes: 18
  }
]

export default data;
